module.exports = __webpack_public_path__ + "img/icon_mute.a14aaf7e.svg";